export default {"src":"/_next/static/image/public/images/social_insta_blue.bf1ff65fba52ca6de01744d3fc95202b.svg","height":16,"width":16};